import { Injectable, InjectionToken, inject } from '@angular/core';

import { StorageKeyBuilderStrategy } from './storage-key-builder-strategy.enum';

export interface StorageKeyBuilderConfiguration {
  userId: string;
  sessionId: string;
  prefix?: string;
}

export const STORAGE_KEY_BUILDER_CONFIGURATION = new InjectionToken<StorageKeyBuilderConfiguration>('storageKeyBuilderConfiguration');

@Injectable({
  providedIn: 'root'
})
export class StorageKeyBuilderService {

  private static readonly DEFAULT_PREFIX: string = 'tdWb';

  private KEY_BUILDER_STRATEGIES: Record<string, (key: string) => string> = {
    [StorageKeyBuilderStrategy.KEY_ONLY]:
      (key: string): string => `${this.prefix}${key}`,
    [StorageKeyBuilderStrategy.KEY_USER]:
      (key: string): string => `${this.prefix}${this.userId}${key}`,
    [StorageKeyBuilderStrategy.KEY_USER_SESSION]:
      (key: string): string => `${this.prefix}${this.userId}${this.sessionId}${key}`
  };

  private readonly userId: string = '';
  private readonly sessionId: string = '';
  private readonly prefix: string = StorageKeyBuilderService.DEFAULT_PREFIX;

  constructor() {
    const configuration = inject<StorageKeyBuilderConfiguration>(STORAGE_KEY_BUILDER_CONFIGURATION, { optional: true });

    if (configuration !== null) {
      this.userId = configuration.userId;
      this.sessionId = configuration.sessionId;
      if (configuration.prefix !== undefined ) {
        this.prefix = configuration.prefix;
      }
    }
  }

  getQualifiedKey(key: string, storageKeyBuilderStrategy: StorageKeyBuilderStrategy): string {
    return this.KEY_BUILDER_STRATEGIES[storageKeyBuilderStrategy](key);
  }
}
